import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions
import { getDocDataByRef } from "../../models/DataFunctions";

const sendSmartEmailInvoice = async (
  emails,
  cc_emails,
  bcc_emails,
  dropped_files = [],
  message,
  sujet,
  token,

  devis_id,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + "notification/smart-email/devis/" + devis_id;

  // Retrieve users from the organization
  const db = getFirestore();

  // EMAILS TO SEND TO

  // stop here

  // Define the request body
  const body = {
    emails: emails,
    cc_emails: cc_emails,
    bcc_emails: bcc_emails,
    message: message,
    sujet: sujet,
    prefix_url: "",
    files: dropped_files,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  let start = new Date();
  // Make the POST request
  const response = await fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body), // Encode the body as JSON
  });

  const response_text = await response.text();

  // Logging is best-effort: never let a logging failure mask the real send
  // result (or report a failure when the email was actually sent).
  try {
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (currentUser) {
      const userRef = doc(db, "user", currentUser.uid);
      const userSnapshot = await getDoc(checkDB(userRef));
      if (userSnapshot.exists()) {
        const org_id = userSnapshot.get("org_id");
        let end = new Date();
        let elapsed = end - start;
        await addLogDocument(
          url,
          prefix,
          userRef, // Only log the userRef ID
          org_id,
          response.status.toString(),
          "", // folderid
          "", // docid
          JSON.stringify(body), // request body as string
          response_text,
          "POST",
          elapsed
        );
      }
    }
  } catch (logError) {
    console.error(`Failed to log email send: ${logError.message}`);
  }

  // Surface failures to the caller so the UI can report them.
  if (!response.ok) {
    console.error(`Failed to send email: ${response.status}`);
    throw new Error(
      `Échec de l'envoi de l'email (${response.status})${
        response_text ? ` : ${response_text}` : ""
      }`
    );
  }

  return "Email sent successfully";
};

export default sendSmartEmailInvoice;
